var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"score"},[_c('div',{staticClass:"score__bar"},[_c('div',{staticClass:"score__filler",style:(_vm.style)}),_vm._v(" "),_c('p',{staticClass:"score__text"},[_vm._v(_vm._s(Math.round(_vm.usedPercentage))+" / 100")])]),_vm._v(" "),_c('div',{staticStyle:{"clear":"both"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-543710c4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Score.vue
// module id = YVsT
// module chunks = 0